import { PermissionsConjunction } from 'frontend-container/components/Menu/authorization/types';
import { MenuElement } from 'frontend-container/components/Menu/types';

import {
  HousekeepingSettingCode,
  propertyPermissionKeys,
} from '@ac/library-api';
import { acConfig } from '@ac/library-utils/dist/declarations';
import { IconName } from '@ac/web-components';

const housekeepingPermissions = propertyPermissionKeys.housekeeping;

export const housekeepingMenu: MenuElement = {
  translation: 'MENU.HOUSEKEEPING.TITLE',
  icon: IconName.housekeeping,
  id: 'menu-housekeeping',
  settings: [HousekeepingSettingCode.UseHousekeepingFunctionality],
  items: [
    {
      link: `${acConfig.newFrontendUrls.housekeeping}/:id/dashboard`,
      aliases: [acConfig.newFrontendUrls.housekeeping],
      code: 'HousekeepingDashboard',
      translation: 'MENU.HOUSEKEEPING.ITEMS.DASHBOARD',
      permissionsConfiguration: {
        permissions: [housekeepingPermissions.rooms.view],
        permissionsConjunction: PermissionsConjunction.And,
      },
      keyboardShortcutWindows: 'alt+ctrl+k',
      keyboardShortcutMac: '⌥+⌘+k',
      keyCode: 75,
    },
    {
      link: `${acConfig.newFrontendUrls.housekeeping}/:id/attendant-assignments`,
      translation: 'MENU.HOUSEKEEPING.ITEMS.ATTENDANT_ASSIGNMENT',
      permissionsConfiguration: {
        permissions: [housekeepingPermissions.attendantAssignment.view],
        permissionsConjunction: PermissionsConjunction.And,
      },
      keyboardShortcutWindows: 'alt+ctrl+d',
      keyboardShortcutMac: '⌥+⌘+d',
      keyCode: 68,
    },
    {
      link: `${acConfig.newFrontendUrls.housekeeping}/:id/maintenance-dashboard`,
      translation: 'MENU.HOUSEKEEPING.ITEMS.DASHBOARD_MAINTENANCE',
      permissionsConfiguration: {
        permissions: [housekeepingPermissions.maintenance.view],
        permissionsConjunction: PermissionsConjunction.And,
      },
      keyboardShortcutWindows: 'alt+ctrl+o',
      keyboardShortcutMac: '⌥+⌘+o',
      keyCode: 79,
    },
    {
      link: `${acConfig.newFrontendUrls.housekeeping}/:id/room-history`,
      translation: 'MENU.HOUSEKEEPING.ITEMS.ROOM_HISTORY',
      permissionsConfiguration: {
        permissions: [housekeepingPermissions.roomsHistory.view],
        permissionsConjunction: PermissionsConjunction.And,
      },
      keyboardShortcutWindows: 'alt+ctrl+y',
      keyboardShortcutMac: '⌥+⌘+y',
      keyCode: 89,
    },
  ],
};
